$(document).ready(function () {

    /**
     * Handlebars helper to serialize the context.
     * @example {{serialize this}}
     * @param {Object} context - The context to serialize.
     * @returns {Object} The serialized context.
     */
    Handlebars.registerHelper('serialize', function (context) {
        return (context);
    });

    /**
     * Handlebars helper to convert the context to a JSON string.
     * @example {{json this}}
     * @param {Object} context - The context to convert.
     * @returns {string} The JSON string representation of the context.
     */
    Handlebars.registerHelper('json', function (context) {
        return JSON.stringify(context);
    });

    /**
     * Handlebars helper to check if two arguments are equal.
     * @example {{#equals arg1 arg2}}...{{else}}...{{/equals}}
     * @param {any} arg1 - The first argument.
     * @param {any} arg2 - The second argument.
     * @param {Object} context - The Handlebars context.
     * @returns {string} The rendered block if the arguments are equal, otherwise the inverse block.
     */
    Handlebars.registerHelper('equals', function (arg1, arg2, context) {
        if (arg1 == arg2) {
            return context.fn(this);
        } else {
            return context.inverse(this);
        }
    });

    /**
     * Handlebars helper to check if two arguments are not equal.
     * @example {{#notEquals arg1 arg2}}...{{else}}...{{/notEquals}}
     * @param {any} arg1 - The first argument.
     * @param {any} arg2 - The second argument.
     * @param {Object} context - The Handlebars context.
     * @returns {string} The rendered block if the arguments are not equal, otherwise the inverse block.
     */
    Handlebars.registerHelper('notEquals', function (arg1, arg2, context) {
        if (arg1 != arg2) {
            return context.fn(this);
        } else {
            return context.inverse(this);
        }
    });

    /**
     * Handlebars helper to check if a string contains another string.
     * @example {{#contains arg1 arg2}}...{{else}}...{{/contains}}
     * @param {string} arg1 - The string to search within.
     * @param {string} arg2 - The string to search for.
     * @param {Object} context - The Handlebars context.
     * @returns {string} The rendered block if arg1 contains arg2, otherwise the inverse block.
     */
    Handlebars.registerHelper('contains', function (arg1, arg2, context) {
        if (typeof arg1 === 'string' && typeof arg2 === 'string' && arg1.includes(arg2)) {
            return context.fn(this);
        } else {
            return context.inverse(this);
        }
    });

    /**
     * Handlebars helper to check if a string does not contain another string.
     * @example {{#notContains arg1 arg2}}...{{else}}...{{/notContains}}
     * @param {string} arg1 - The string to search within.
     * @param {string} arg2 - The string to search for.
     * @param {Object} context - The Handlebars context.
     * @returns {string} The rendered block if arg1 does not contain arg2, otherwise the inverse block.
     */
    Handlebars.registerHelper('notContains', function (arg1, arg2, context) {
        if (typeof arg1 === 'string' && typeof arg2 === 'string' && !arg1.includes(arg2)) {
            return context.fn(this);
        } else {
            return context.inverse(this);
        }
    });

    /**
     * Handlebars helper to check if a string is null or empty.
     * @example {{#if (string_IsNullOrEmpty text)}}...{{else}}...{{/if}}
     * @param {string} text - The string to check.
     * @returns {boolean} True if the string is null or empty, otherwise false.
     */
    Handlebars.registerHelper('string_IsNullOrEmpty', function (text) {
        return text === undefined
            || text === null
            || typeof text !== 'string'
            || typeof text.trim !== 'function'
            || text.trim() === '';
    });

    /**
     * Handlebars helper to format a number according to a specified format.
     * @example {{formatNumber PriceN '#.#0'}}
     * @param {number} number - The number to format.
     * @param {string} format - The format string.
     * @returns {string} The formatted number.
     */
    Handlebars.registerHelper('formatNumber', function (number, format, context) {
        var regex = /#\.#{0,4}[0-9]+/i;

        if (regex.test(format) && !isNaN(number)) {
            var decimal, place;

            decimal = format.split('.')[1];
            place = decimal.indexOf('0');
            number = number.toFixed(place + 1);

            if (LhApp.Context.Currency.DecimalSeparator === ',')
                number = number.replace('.', ',');

            return number;
        }
    });

    /**
     * Handlebars helper to convert a string to lowercase.
     * @example {{toLowerCase input}}
     * @param {string} input - The string to convert.
     * @returns {string} The lowercase string.
     */
    Handlebars.registerHelper('toLowerCase', function (input) {
        if (!input || typeof input !== 'string') {
            return '';
        }
        return input.toLowerCase();
    });

    /**
     * Handlebars helper to format a string using placeholders.
     * @example {{stringFormat "Hello, {0} {1}!" firstName lastName}}
     * @param {string} format - The format string.
     * @param {...any} args - The arguments to replace the placeholders.
     * @returns {string} The formatted string.
     */
    Handlebars.registerHelper('stringFormat', function (format /*, arg1, arg2, ... */) {
        var args = Array.prototype.slice.call(arguments, 1, arguments.length - 1);

        if (!format || typeof format !== 'string') {
            return '';
        }

        var result = format;

        for (var i = 0; i < args.length; i++) {
            var arg = args[i];
            if (arg != null) {
                result = result.replace('{' + i + '}', arg.toString());
            }
        }

        return new Handlebars.SafeString(result);
    });

    /**
     * Handlebars helper to convert a number to a string with a specified separator.
     * @example {{numberToString value ","}}
     * @param {number} value - The number to convert.
     * @param {string} separator - The separator to use.
     * @returns {string} The formatted number as a string.
     */
    Handlebars.registerHelper('numberToString', function (value, separator) {
        var number = parseFloat(value);
        if (isNaN(number) || !separator) {
            return '';
        }

        var result = number.toFixed(2);

        if (separator !== '.') {
            result = result.replace('.', separator);
        }

        return new Handlebars.SafeString(result);
    });

    /**
     * Handlebars helper to format a date according to a specified format.
     * @example {{formatDateTime date "yyyy-MM-dd HH:mm:ss"}}
     * @param {string|Date} value - The date to format.
     * @param {string} format - The format string.
     * @returns {string} The formatted date.
     */
    Handlebars.registerHelper('formatDateTime', function (value, format) {
        if (!value || !format) {
            return '';
        }

        var date = new Date(value);
        if (isNaN(date.getTime())) {
            return '';
        }

        var result = format
            .replace('yyyy', date.getFullYear())
            .replace('MM', ('0' + (date.getMonth() + 1)).slice(-2))
            .replace('dd', ('0' + date.getDate()).slice(-2))
            .replace('HH', ('0' + date.getHours()).slice(-2))
            .replace('mm', ('0' + date.getMinutes()).slice(-2))
            .replace('ss', ('0' + date.getSeconds()).slice(-2));

        return new Handlebars.SafeString(result);
    });

    /**
     * Handlebars helper to get a value from a dictionary by key.
     * @example {{GetFromDict dictionary key}}
     * @param {Object} dictionary - The dictionary object.
     * @param {string|number} key - The key to look up.
     * @returns {string} The value associated with the key.
     */
    Handlebars.registerHelper('GetFromDict', function (dictionary, key) {
        if (!dictionary || typeof dictionary !== 'object') {
            return '';
        }

        var parsedKey = parseInt(key, 10);

        if (!isNaN(parsedKey) && dictionary.hasOwnProperty(parsedKey)) {
            return new Handlebars.SafeString(dictionary[parsedKey]);
        }

        if (dictionary.hasOwnProperty(key)) {
            return new Handlebars.SafeString(dictionary[key]);
        }

        return '';
    });

    /**
     * Handlebars helper to look up a property in an object.
     * @example {{lookup obj prop isSafe}}
     * @param {Object} obj - The object to look up.
     * @param {string} prop - The property to look up.
     * @param {boolean} [isSafe=false] - Whether to return a SafeString.
     * @returns {string} The value of the property.
     */
    Handlebars.registerHelper('lookup', function (obj, prop /*, isSafe */) {
        var isSafe = false;
        if (arguments.length > 2 && typeof arguments[2] === 'boolean') {
            isSafe = arguments[2];
        }

        if (!obj || !prop) {
            return '';
        }

        var value = obj[prop];
        if (typeof value === 'undefined') {
            return '';
        }

        return isSafe ? new Handlebars.SafeString(value) : value;
    });
});
